import { parse, isValid } from 'date-fns'
import { Cell } from './data'

export const parseTimeString = (timeStr: string): Date => {
    try {
        const referenceDate = new Date(1970, 0, 1)
        const parsedDate = parse(timeStr.trim(), 'hh:mm a', referenceDate)

        return isValid(parsedDate) ? parsedDate : referenceDate
    } catch {
        return new Date(1970, 0, 1)
    }
}

export const compareTimeStrings = (timeA: string, timeB: string): number => {
    const dateA = parseTimeString(timeA)
    const dateB = parseTimeString(timeB)
    return dateA.getTime() - dateB.getTime()
}

export const createTimeColumnSorter = (
    timeColumnIndex: number,
    direction: 'asc' | 'desc' | 'dsc' = 'asc',
) => {
    return (rowA: Cell[], rowB: Cell[]): number => {
        const timeA = rowA[timeColumnIndex]?.value || ''
        const timeB = rowB[timeColumnIndex]?.value || ''

        const comparison = compareTimeStrings(timeA, timeB)
        return direction === 'desc' || direction === 'dsc'
            ? -comparison
            : comparison
    }
}

export const sortTableDataByTime = (
    data: Cell[][],
    timeColumnIndex: number,
    direction: 'asc' | 'desc' | 'dsc' = 'asc',
): Cell[][] => {
    const sorter = createTimeColumnSorter(timeColumnIndex, direction)
    return [...data].sort(sorter)
}
